<template>
  <!-- R2 登录页页头  author: zhangxiaofeng-->
  <div :class="['login-header', isWhite ? 'white' : '']">
    <router-link to="/index">
      <logo class="logo-instance" :is-white="isWhite"></logo>
    </router-link>
    <div class="f-cb">
      <div v-if="!user.userName" class="link-item login-btn" :class="isWhite?'login-btn-white':''">
        <a href="javascript: void(0);" @click = "showLogin">
          登录
        </a>
      </div>
      <div v-if="user.userName" class="link-item enter-btn">
        <a href="javascript: void(0);" @click="goPage(user.userType)">
          进入造价云
        </a>
      </div>
      <!--<div v-if="!user.userName" class="link-item register-btn">-->
        <!--<a href="javascript: void(0);">-->
          <!--获取账号-->
        <!--</a>-->
        <!--<div class="switch-cont">-->
          <!--<div class="switch-box">-->
            <!--<ul>-->
              <!--<li>-->
                <!--<a href="https://account.glodon.com/register" @click="sentLog(100101030)" target="_blank">-->
                  <!--注册个人账号-->
                  <!--&lt;!&ndash;<i class="r2-icon-action_help_outline"></i>&ndash;&gt;-->
                <!--</a>-->
                <!--<i class="split-line"></i>-->
              <!--</li>-->
              <!--&lt;!&ndash;-->
              <!--<li>-->
                <!--<a href="javascript: void(0);">-->
                  <!--获取员工账号-->
                <!--</a>-->
                <!--<i class="split-line"></i>-->
              <!--</li>-->
              <!--&ndash;&gt;-->
              <!--<li>-->
                <!--<router-link to="/findAdmin" @click.native="sentLog(100101031)">-->
                  <!--查询管理员账号-->
                  <!--&lt;!&ndash;<i class="r2-icon-action_help_outline"></i>&ndash;&gt;-->
                <!--</router-link>-->
              <!--</li>-->
            <!--</ul>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <!-- <div class="link-item apply-btn">
        <a href="javascript: void(0);" @click="handleJoinEnt()">
          加入企业
        </a>
      </div> -->
      <a class="link-item link-item-text" href="javascript: void(0);" @click.stop="experience">体验中心</a>
      <!-- <a class="link-item link-item-text" href="javascript: void(0);" @click.stop="downloadHelpDoc">帮助</a> -->
      <span class="link-item link-item-text split-line"></span>
      <router-link to="/vip" class="link-item link-item-text" @click.native="sentLog(100101027)">
        套餐
      </router-link>
      <!-- <router-link to="/production" class="link-item link-item-text" @click.native="sentLog(100101029)">内容中心</router-link> -->
      <router-link to="/index" class="link-item link-item-text">首页</router-link>
    </div>
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .login-header{
    width: 1200px;
    height: 72px;
    margin: 0 auto;
    position: relative;
    .link-item{
      float: right;
      margin-left: 24px;
      height: 36px;
      line-height: 36px;
      margin-top: 18px;
      font-size:16px;
      font-weight:500;
      color:rgb(255,255,255);
      &:last-child{
        margin-left: 0;
      }
    }
    .link-item-text{
      text-shadow: 0px 0px 4px rgba(33,37,48,0.2);
    }
    &.white{
      background: #fff;
      .link-item{
        color: rgba(33,37,48,0.8);
        text-shadow: none;
      }
      .split-line{
        background: rgba(33,37,48,0.15)
      }
      .login-btn-white{
        background: rgba(32,121,250,1);
        a{
          color: #fff;
        }
      }
    }
    .logo-instance{
      float: left;
      margin-top: 15px;
    }
    .register-btn {
      margin-left: 12px;
    }
    .apply-btn {
      margin-left: 36px;
    }
    .register-btn, .apply-btn{
      width:112px;
      text-align: center;
      border-radius:18px;
      background:rgba(0, 0, 0, 0.4);
      position: relative;
      &>a{
        display: inline-block;
        height: 100%;
        width: 100%;
        font-size: 16px;
        border-radius:18px;
        color:rgb(255,255,255);
        /*
        &.active{
          background:rgb(32,121,250);
        }
        */
      }
      .switch-cont{
        display: none;
        width: 146px;
        position: absolute;
        top: 30px;
        right: -16px;
        padding-top: 17px;
        animation: dialog-fade-in .3s;
        .switch-box{
          text-align: left;
          background-color: #fff;
          width: 146px;
          min-height: 58px;
          height: auto;
          box-shadow:0px 2px 8px 0px rgba(33,37,48,0.2);
          border-radius:4px;
          position: relative;
          box-sizing: border-box;
          padding: 20px 0;
          li{
            width: 100%;
            height: 22px;
            margin-bottom: 35px;
            position: relative;
            line-height: 22px;
            i.split-line{
              display: inline-block;
              width: 98px;
              height:1px;
              background:rgba(33,37,48,0.1);
              position: absolute;
              left: 24px;
              right: auto;
              top: 39px;
              z-index: 10;
              margin-top: 0;
            }
            &:last-child{
              margin-bottom: 0;
            }
            a{
              display: inline-block;
              width: 100%;
              height: 100%;
              padding: 0 24px;
              box-sizing: border-box;
              font-size: 14px;
              color:rgba(33,37,48,0.75);
            }
            i{
              position: absolute;
              right: 20px;
            }
            &:hover{
              a{
                color:rgb(32,121,250);
              }
              i{
                color:rgba(33,37,48,0.75);
              }
            }
          }
        }
      }
      &:hover{
        box-shadow:0px 1px 4px 0px rgba(0,0,0,0.3);
        border-color: rgb(32,121,250);
        &>a{
          background: #FFF;
          color: rgba(32,121,250,1);
        }
        .switch-cont{
          display: block;
        }
      }
    }
    .enter-btn{
      width:128px;
      text-align: center;
      margin-left: 12px;
      position: relative;
      background:rgba(0,0,0,0.4);
      border-radius:18px;
      &>a{
        display: inline-block;
        height: 36px;
        width: 100%;
        line-height: 36px;
        font-size: 16px;
        border-radius:18px;
        color:rgb(255,255,255);
      }
      &:hover{
        box-shadow:0px 1px 4px 0px rgba(0,0,0,0.3);
        border-color: rgb(32,121,250);
        &>a{
          background: #FFF;
          color: rgba(32,121,250,1);
        }
      }

    }
    .login-btn{
      width:88px;
      text-align: center;
      border-radius:18px;
      margin-left: 12px;
      position: relative;
      background: #FFF;
      &>a{
        display: inline-block;
        height: 100%;
        width: 100%;
        font-size: 16px;
        border-radius:18px;
        color:#000;
      }
      &:hover{
        box-shadow:0px 1px 4px 0px rgba(0,0,0,0.3);
        &>a{
          background: #FFF;
          color: rgba(32,121,250,1);
        }
      }
    }
    .split-line{
      width: 1px;
      height: 16px;
      background:rgba(255,255,255,0.4);
      margin-top: 27px;
    }
  }
  //视频页不要白底的样式了，2020-06-11
  .white{
    background-color: #fff;
    .link-item{
      color:rgba(33,37,48,0.8);
      &:hover{
        color: #2079FA;
      }
      &:active{
        color:rgba(32,121,250,1);
      }
    }
    .link-item.router-link-active{
      color:rgba(32,121,250,1);
    }
    .split-line{
      background:rgba(33,37,48,0.15);
    }
    .register-btn, .apply-btn{
      border-radius:18px;
      border:1px solid rgba(32,121,250,1);
      box-shadow: none;
      background: #fff;
      &:hover{
        &>a{
          background:rgba(76,147,251,1);
          border-radius:18px;
          color: #FFF;
          border:1px solid rgba(76,147,251,1);
          box-shadow: none;
        }
        box-shadow: none;
        border-color: transparent;
      }
      &>a{
        color:rgba(32,121,250,1);
      }
    }
    .enter-btn{
      border-radius:18px;
      border:1px solid rgba(32,121,250,1);
      box-shadow: none;
      background: #fff;
      &:hover{
        &>a{
          background:rgba(76,147,251,1);
          box-shadow: none;
          color: #FFF;
        }
        box-shadow: none;
        border-color: transparent;
      }
      &>a{
        color:rgba(32,121,250,1);
      }
    }
    .login-btn{
      border-radius:18px;
      &:hover{
        &>a{
          background:rgba(76,147,251,1);
          border-radius:18px;
          border: none;
          box-shadow: none;
          color: #FFF;
        }
        border:none;
        box-shadow: none;
      }
      &>a{
        color: #fff;
      }
    }
  }
</style>
<script>
import api from 'service'
import Logo from '_c/Logo.vue'
import { getCookie, delCookie, deleteAllCookie } from '@/assets/utils/CommonUtil'
import {parseTime} from '@/assets/utils'
import LoginService from '@/assets/service/login'

// 兼容IE10
const hostname = window.location.hostname
if (window['context'] === undefined) {
  if (!window.location.origin) {
    window.location.origin = window.location.protocol + '//' + hostname + (window.location.port ? ':' + window.location.port : '')
  }
  window['context'] = location.origin + '/V6.0'
}
if (!window.location.origin) {
  window.location.origin = window.location.protocol + '//' + hostname + (window.location.port ? ':' + window.location.port : '')
}
let urlDomain = window.location.origin

// 灰度跳转
const grayDomain = getCookie('grayMenuDomain')
if (typeof grayDomain === 'string' && grayDomain) {
  switch (hostname) {
    case 'zjytest.glodon.com':
      urlDomain = 'https://zjytest-gray.glodon.com'
      break
    case 'zjy-pre.glodon.com':
      urlDomain = 'https://zjy-gray-pre.glodon.com'
      break
    case 'zjy.glodon.com':
      urlDomain = 'https://zjy-gray.glodon.com'
      break
    default:
  }
}

export default {
  name: 'HeaderLogin',
  props: {
    isWhite: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleJoinEnt () {
      this.sentLog(100117102)
      this.$emit('changeJoinShow', true)
    },
    parseTime (t) {
      return parseTime(t)
    },
    showLogin () {
      this.sentLog(100101035)
      this.$emit('changeLoginShow', true)
    },
    // 2.2 调用登录接口成功后 预跳转到指定页面 or 登录用户点击 “进入造价云管理平台” 时
    goPage (userType){
      this.sentLog(100101034)
      // 在两个页签 一个页签 用户已退出时 点击 进入进入造价云管理平台  时 刷新页面
      const zjyToken = getCookie('ZJYTOKEN')
      const zjyUserInfo = getCookie('ZJYUSERINFO')
      const geipToken = getCookie('GEIPTOKEN')
      const tenantId = getCookie('tenantId')
      if (!zjyToken || !zjyUserInfo || !geipToken || !tenantId) {
        window.location.reload()
      }
      if (!userType){
        userType = this.user.userType
      }
      const query = this.$route.query
      if (query && query.fromPath) {
        // 若是从某个页面 登录超时 后 跳转到登录页则登录后 直接跳转到之前页面
        const fromPath = decodeURIComponent(query.fromPath)
        if (/^http[s]?:\/\//.test(fromPath)) {
          // 要先去用户中心单点登录
          // window.location.href = fromPath
          this.singleLogin(fromPath)
        } else {
          // this.$router.push({
          //   path: fromPath
          // })
          const preUrl = `${urlDomain}/#${fromPath}`
          this.singleLogin(preUrl)
        }
      } else {
        this.singleLogin(`${urlDomain}/#/home`)
      }
    },
    // 2.3 单点登录
    singleLogin (path){
      LoginService.singleLogin({
        redirectUrl: path
      }).then((res) => {
        if (+res.code === 200){
          sessionStorage.removeItem('privacyShow')
          // console.dir(res.data)
          window.location.href = res.data
          return
        } else {
          deleteAllCookie()
          window.location.href = `${urlDomain}`
        }
        this.loginError = '登录失败'
      }).catch(() => {
        deleteAllCookie()
        window.location.href = `${urlDomain}`
        this.loginError = '登录失败'
      })
    },
    // 4. 帮助文档点击
    downloadHelpDoc (){
      this.sentLog(100101028)
      const url = api.common.downloadHelpDoc()
      window.common.downloadFile(url)
    },
    // 体验中心
    experience (){
      if (getCookie('accountToken')){
        delCookie('accountToken')
      }
      window.open('#/free-license')
    }
  },
  data () {
    return {
      user: {}
    }
  },
  created () {
    let userInfo = getCookie('ZJYUSERINFO') || {}
    this.user = userInfo
  },
  components: {
    Logo
  }
}
</script>
